module.exports = __webpack_public_path__ + "static/media/ceo.f2ce4709.svg";